module.exports = __webpack_public_path__ + "static/media/lightChatIcon.1d7d279a.svg";